import { onDeleteTagForFolderChanged } from '../actions/publicActions';
import { onDeleteTagForFolderUpdateSuccess } from '../actions/internalActions';
import updateFolderRetentionPolicy from '../services/updateFolderRetentionPolicy';
import {
    DELETE_TAG_FIELD_URI,
    DELETE_INHERIT_SUBMENU_ITEM_IDENTIFIER,
} from '../utils/retentionPolicyConstants';
import { orchestrator } from 'satcheljs';
import RetentionTagType from 'owa-service/lib/contract/RetentionTagType';
import FolderInfoResponseMessage from 'owa-service/lib/contract/FolderInfoResponseMessage';
import isSelectedPolicyDifferentForFolder from '../helpers/isSelectedPolicyDifferentForFolder';
import { trace } from 'owa-trace';
import logRetentionPolicySelected from '../utils/logging';

/**
 * Responsible for updating the folder's delete tag by service call and then at client if call is successful
 */
export default orchestrator(onDeleteTagForFolderChanged, async actionMessage => {
    const { folder, tagValue, actionSource } = actionMessage;
    const isSelectedPolicyDifferent = isSelectedPolicyDifferentForFolder({
        folder: folder,
        retentionId: tagValue,
        inheritSubMenuIdentifier: DELETE_INHERIT_SUBMENU_ITEM_IDENTIFIER,
    });

    if (!isSelectedPolicyDifferent) {
        return;
    }
    try {
        const deleteTag: RetentionTagType =
            tagValue === DELETE_INHERIT_SUBMENU_ITEM_IDENTIFIER
                ? null
                : { Value: tagValue, IsExplicit: true };

        const folderId = folder.DistinguishedFolderId || folder.FolderId.Id;
        const response: FolderInfoResponseMessage = await updateFolderRetentionPolicy(
            folderId,
            DELETE_TAG_FIELD_URI,
            deleteTag
        );
        if (response.ResponseClass === 'Success') {
            onDeleteTagForFolderUpdateSuccess(folder, deleteTag);
        }
        logRetentionPolicySelected({
            isArchiveTag: false,
            actionSource: actionSource,
            responseClass: response.ResponseClass,
        });
    } catch (error) {
        trace.error('Error while updating folder delete tag' + error);
    }
});
